import { render, staticRenderFns } from "./TypoList.vue?vue&type=template&id=7fce0168&scoped=true"
import script from "./TypoList.vue?vue&type=script&lang=ts"
export * from "./TypoList.vue?vue&type=script&lang=ts"
import style0 from "./TypoList.vue?vue&type=style&index=0&id=7fce0168&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fce0168",
  null
  
)

export default component.exports